export default "__VITE_ASSET__BCRcWSPL__"